import * as React from "react"

import { cn } from "@/lib/utils"

// Native date inputs are hard-locked to LTR by Chromium, which garbles the
// Arabic placeholder (قنس/موي/رهش). This wrapper hides the broken native
// text while empty (see .date-empty-rtl in index.css) and shows a correct
// RTL Arabic label instead; filled values render as usual.
const DateInput = React.forwardRef(({ className, value, ...props }, ref) => {
  const empty = !value;
  return (
    <div className={cn("relative", className)}>
      <input
        type="date"
        value={value}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
          empty && "date-empty-rtl"
        )}
        ref={ref}
        {...props} />
      {empty && (
        <span aria-hidden="true"
          className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-xs text-slate-400">
          يوم/شهر/سنة
        </span>
      )}
    </div>
  );
})
DateInput.displayName = "DateInput"

export { DateInput }
